import Email from "@pages/Pendencia/Email/Email";

export default Email;
